import React, { Component } from 'react';
import { Tabs, Tab } from 'react-bootstrap';

import { FontStyles } from './FontStyles';
import { BackgroundStyles } from './BackgroundStyles';
import { MarginStyles } from './MarginStyles';
import { CircleElementStyles } from './CircleElementStyles';

import { FontStyleCommand } from '../commands/FontStyleCommand';
import { BackgroundStyleCommand } from '../commands/BackgroundStyleCommand';
import { MarginStyleCommand } from '../commands/MarginStyleCommand';
import { CircleElementStyleCommand } from '../commands/CircleElementStyleCommand';

export class ComponentStyles extends Component {
    constructor(props) {
        super(props);

        this.state = {
            targetsFonts: {
                data: []
            },
            targetsBackgrounds: {
                data: []
            },
            targetsMargins: {
                data: []
            },
            targetsCircleElements: {
                data: []
            },
            actions: {
                isLoadingFontsTargets: true,
                isLoadingBackgroundsTargets: true,
                isLoadingMarginsTargets: true,
                isLoadingCircleElementsTargets: true
            },
            commands: {
                fontStyleCommand: new FontStyleCommand(props.appName),
                backgroundStyleCommand: new BackgroundStyleCommand(props.appName),
                marginStyleCommand: new MarginStyleCommand(props.appName),
                circleElementStyleCommand: new CircleElementStyleCommand(props.appName)
            },
            componentsWithLineColor: [
                "LineInformation",
                "SimpleText",
                "HorizontalStopsList",
                "VerticalStopsList",
                "HorizontalTabularDayTimesheet",
                "VerticalTabularDayTimesheet",
                "Exceptions",
                "PointCaption"
            ]
        }

        this.getAvailableFontsTargets(false);
        this.getAvailableBackgroundsTargets(false);
        this.getAvailableMarginTargets(false);
        this.getAvailableCircleElementsTargets(false);
    }

    getAvailableFontsTargets(resetData) {
        if (resetData) {
            const { actions } = this.state;

            actions.isLoadingFontsTargets = true;

            this.setState({
                targetsFonts: {
                    data: []
                },
                actions: actions
            });
        }

        const { commands } = this.state;
        commands.fontStyleCommand.getAvailableTargets(
            this.props.componentType,
            (a) => this.fontsTargetsSuccessCallback(a),
            (a) => this.errorCallback(a)
        );
    }

    getAvailableBackgroundsTargets(resetData) {
        if (resetData) {
            const { actions } = this.state;

            actions.isLoadingBackgroundsTargets = true;

            this.setState({
                targetsBackgrounds: {
                    data: []
                },
                actions: actions
            });
        }

        const { commands } = this.state;
        commands.backgroundStyleCommand.getAvailableTargets(
            this.props.componentType,
            (a) => this.backgroundsTargetsSuccessCallback(a),
            (a) => this.errorCallback(a)
        );
    }

    getAvailableMarginTargets(resetData) {
        if (resetData) {
            const { actions } = this.state;

            actions.isLoadingMarginsTargets = true;

            this.setState({
                targetsMargins: {
                    data: []
                },
                actions: actions
            });
        }

        const { commands } = this.state;
        commands.marginStyleCommand.getAvailableTargets(
            this.props.componentType,
            (a) => this.marginsTargetsSuccessCallback(a),
            (a) => this.errorCallback(a)
        );
    }

    getAvailableCircleElementsTargets(resetData) {
        if (resetData) {
            const { actions } = this.state;

            actions.isLoadingCircleElementsTargets = true;

            this.setState({
                targetsCircleElements: {
                    data: []
                },
                actions: actions
            });
        }

        const { commands } = this.state;
        commands.circleElementStyleCommand.getAvailableTargets(
            this.props.componentType,
            (a) => this.circleElementsTargetsSuccessCallback(a),
            (a) => this.errorCallback(a)
        );
    }

    // ---------------------------

    fontsTargetsSuccessCallback(result) {
        const { targetsFonts, actions } = this.state;

        targetsFonts.data = result;
        actions.isLoadingFontsTargets = false;

        this.setState({
            targetsFonts: targetsFonts,
            actions: actions
        });
    }

    backgroundsTargetsSuccessCallback(result) {
        const { targetsBackgrounds, actions } = this.state;

        targetsBackgrounds.data = result;
        actions.isLoadingBackgroundsTargets = false;

        this.setState({
            targetsBackgrounds: targetsBackgrounds,
            actions: actions
        });
    }

    marginsTargetsSuccessCallback(result) {
        const { targetsMargins, actions } = this.state;

        targetsMargins.data = result;
        actions.isLoadingMarginsTargets = false;

        this.setState({
            targetsMargins: targetsMargins,
            actions: actions
        });
    }

    circleElementsTargetsSuccessCallback(result) {
        const { targetsCircleElements, actions } = this.state;

        targetsCircleElements.data = result;
        actions.isLoadingCircleElementsTargets = false;

        this.setState({
            targetsCircleElements: targetsCircleElements,
            actions: actions
        });
    }

    errorCallback(message) {
        const { actions } = this.state;

        actions.isLoadingFontsTargets = false;
        actions.isLoadingBackgroundsTargets = false;
        actions.isLoadingCircleElementsTargets = false;

        this.setState({
            actions: actions,
            message: {
                show: true,
                message: message,
                style: "danger",
                title: "Erro",
                icon: "remove"
            }
        });
    }

    // ---------------------

    renderFontStyleTab(isLoadingTargets, targets, fonts) {
        if (0 === targets.data.length && !isLoadingTargets) {
            return null;
        }

        const { componentsWithLineColor } = this.state;

        return (
            <Tab eventKey={1} title="Tipos de Letra" disabled={isLoadingTargets}>
                <FontStyles
                    data={fonts}
                    targets={targets}
                    isLoadingTargets={isLoadingTargets}
                    appName={this.props.appName}
                        onUpdateFonts={(a) => this.props.onUpdateStyles(a, "fonts")}
                        canUseLineColor={componentsWithLineColor.includes(this.props.componentType)} />
            </Tab>
        );
    }

    renderBackgroundStyleTab(isLoadingTargets, targets, backgrounds) {
        if (0 === targets.data.length && !isLoadingTargets) {
            return null;
        }

        const { componentsWithLineColor } = this.state;

        return (
            <Tab eventKey={2} title="Fundos" disabled={isLoadingTargets}>
                <BackgroundStyles
                    data={backgrounds}
                    targets={targets}
                    isLoadingTargets={isLoadingTargets}
                        onUpdateBackgrounds={(a) => this.props.onUpdateStyles(a, "backgrounds")}
                        canUseLineColor={componentsWithLineColor.includes(this.props.componentType)} />
            </Tab>
        );
    }

    renderMarginStyleTab(isLoadingTargets, targets, margins) {
        if (0 === targets.data.length && !isLoadingTargets) {
            return null;
        }

        return (
            <Tab eventKey={3} title="Margens" disabled={isLoadingTargets}>
                <MarginStyles
                    data={margins}
                    targets={targets}
                    isLoadingTargets={isLoadingTargets}
                    onUpdateMargins={(a) => this.props.onUpdateStyles(a, "margins")} />
            </Tab>
        );
    }

    renderCircleElementStyleTab(isLoadingTargets, targets, circleElements) {
        if (0 === targets.data.length && !isLoadingTargets) {
            return null;
        }

        const { componentsWithLineColor } = this.state;

        return (
            <Tab eventKey={4} title="Círculos" disabled={isLoadingTargets}>
                <CircleElementStyles
                    data={circleElements}
                    targets={targets}
                    isLoadingTargets={isLoadingTargets}
                onUpdateCircleElements={(a) => this.props.onUpdateStyles(a, "circleElements")}
                canUseLineColor={componentsWithLineColor.includes(this.props.componentType)} />
            </Tab>
        );
    }

    render() {
        const { fonts, backgrounds, margins, circleElements } = this.props;
        const { targetsFonts, targetsBackgrounds, targetsMargins, targetsCircleElements, actions } = this.state;

        const fontStyleTab = this.renderFontStyleTab(actions.isLoadingFontsTargets, targetsFonts, fonts);
        const backgroundStyleTab = this.renderBackgroundStyleTab(actions.isLoadingBackgroundsTargets, targetsBackgrounds, backgrounds);
        const marginStyleTab = this.renderMarginStyleTab(actions.isLoadingMarginsTargets, targetsMargins, margins);
        const circleElementStyleTab = this.renderCircleElementStyleTab(actions.isLoadingCircleElementsTargets, targetsCircleElements, circleElements);

        if (null === fontStyleTab && null === backgroundStyleTab && null === circleElementStyleTab) {
            return (
                <p>Não existem estilos que possam ser configurados para este tipo de elemento</p>
            )
        }

        return (
            <Tabs id="styles-tab">
                {fontStyleTab}
                {backgroundStyleTab}
                {marginStyleTab}
                {circleElementStyleTab}
            </Tabs>
        );
    }
}
